import { css } from 'lit';

// language=CSS
export const styles =
    css`
        :host {
            height: 100%;
            width: 100%;
            display: grid;
            grid-template-rows: 3.625rem auto;
            grid-template-columns: 15.56rem auto;
        }
        
        lit-brand {
            grid-column: 1 / 2;
            grid-row: 1 / 2;
        }
        
        lit-header {
            grid-column: 2 / 3;
            grid-row: 1 / 2;
            background: white;
        }
        
        lit-navigation {
            grid-column: 1 / 2;
            grid-row: 2 / 3;
        }
        
        #router-outlet {
            grid-column: 2 / 3;
            grid-row: 2 / 3;
            margin: var(--padding-default);
            padding: var(--padding-default);
            background: white;
            border: 1px solid #E8E8E8;
            min-width: var(--content-min-width);
        }
    `;
